<template>
  <span v-if="emailTemplate"
    >{{ actionStyling[action._type].description }} '{{
      emailTemplate.name.substring(0,35)
    }}'</span
  >
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      actionStyling: "automations/actionStyling",
    }),
    emailTemplate() {
      return this.$store.getters["emailTemplates/emailTemplate"](
        this.action.templateId
      );
    },
  },
  async mounted() {
    await this.$store.dispatch("emailTemplates/getAll", false);
  },
};
</script>

<style lang="scss">
</style>